module.exports = __webpack_public_path__ + "static/media/voteapp.9053d99a.mp4";